import {
  Component,
  NgModule,
  OnInit,
  ViewEncapsulation
} from "@angular/core";
import {
  CadastroAgencia,
  SocioAgenciaCadastro
} from "../../model";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators
} from "@angular/forms";
import {
  AgenciaService
} from "../../services";
import {
  NgxMaskModule
} from 'ngx-mask';
import {
  debounceTime
} from "rxjs/operators";
import {
  AMBIENTE
} from '../../app.config';

@Component({
  selector: "sign-up",
  templateUrl: "./sign-up.component.html",
  styleUrls: ["./sign-up.component.scss"],
})

export class SignUpComponent implements OnInit {
  numeroSocios: number = 1;
  form: FormGroup;
  mostrarMensagemErro: boolean = false;
  mostrarMensagemSucesso: boolean = false;
  mensagemSucesso: string = "";
  ambiente = AMBIENTE;
  isChecked: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private agenciaService: AgenciaService
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      razaoSocial: this.formBuilder.control("", [
        Validators.required,
      ]),
      nomeFantasia: this.formBuilder.control("", [
        Validators.required,
      ]),
      cnpjAgencia: this.formBuilder.control("", [
        Validators.required,
        Validators.pattern(/^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/),
      ]),

      //Contatos
      telefonePrincipal: this.formBuilder.control("", [
        Validators.required,
      ]),
      telefoneSecundario: this.formBuilder.control("", [
      ]), // optional
      emailAgencia: this.formBuilder.control("", [
        Validators.required,
        Validators.email,
      ]),
      website: this.formBuilder.control(""), // optional

      //Endereço
      cep: this.formBuilder.control("", [
        Validators.required,
        Validators.pattern(/^\d{5}-\d{3}$/),
      ]),
      logradouro: this.formBuilder.control("", [
        Validators.required,
      ]),
      numero: this.formBuilder.control("", [
        Validators.required,
      ]),
      bairro: this.formBuilder.control("", [
        Validators.required,
      ]),
      cidade: this.formBuilder.control("", [
        Validators.required,
      ]),
      estado: this.formBuilder.control("", [
        Validators.required,
      ]),
      complemento: this.formBuilder.control(""),
    });

    this.aplicarMascaraTelefone();
    this.aplicarMascaraCEP();
    this.aplicarMascaraCNPJ();
  }

  AlteraisChecked(check: any) {
    this.isChecked = check.target.checked;
    console.log(this.isChecked);
  }

  getFormValidationErrors() {
    const invalidFields: any[] = [];
    Object.keys(this.form.controls).forEach(key => {
      const controlErrors = this.form.get(key).errors;
      if (controlErrors) {
        Object.keys(controlErrors).forEach(keyError => {
          invalidFields.push({
            field: key,
            error: keyError,
            value: controlErrors[keyError]
          });
        });
      }
    });
    return invalidFields;
  }

  enviarCadastro() {
    this.mostrarMensagemErro = false;

    const arquivosObrigatorios = [
      // 'contratoSocial',
      // 'cartaoCPJ',
      // 'comprovanteEndereco',
      // 'identificacaoBancaria',
      // 'doccadastur',
      // 'docembratur',
      // 'logoempresa'
    ];

    const formData = new FormData();

    // Adiciona todos os campos ao FormData
    for (const key in this.form.controls) {
      const control = this.form.get(key);

      if (control.value instanceof File) {
        formData.append(key, control.value);
      } else {
        formData.append(key, control.value || '');
      }
    }

    // Realiza o envio do cadastro
    this.agenciaService.criarCadastroAgencia(formData).subscribe(
      (dados) => {
        this.mostrarMensagemSucesso = dados;
        this.form.reset();
        this.mensagemSucesso = "Cadastro realizado com sucesso! Aguarde a análise, e entraremos em contato.";
      },
      (error) => {
        console.error('Erro ao cadastrar agência:', error);
      }
    );
  }

  // MÁSCARAS DE INPUT

  aplicarMascaraTelefone() {
    const camposTelefone = ['telefonePrincipal', 'telefoneSecundario']; -
    camposTelefone.forEach(campo => {
      const telefoneControl = this.form.get(campo);

      if (telefoneControl) {
        telefoneControl.valueChanges.subscribe(value => {
          if (value) {
            const telefoneFormatado = this.formatarTelefone(value);
            telefoneControl.setValue(telefoneFormatado, {
              emitEvent: false
            });
          }
        });
      }
    });
  }

  formatarTelefone(value: string): string {
    const telefoneNumeros = value.replace(/\D/g, '');

    return telefoneNumeros
      .replace(/^(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{4})\d+?$/, '$1');
  }


  aplicarMascaraCNPJ() {
    const cnpjControl = this.form.get('cnpjAgencia');
    if (cnpjControl) {
      cnpjControl.valueChanges.subscribe(value => {
        if (value) {
          const cnpjFormatado = this.formatarCNPJ(value);
          cnpjControl.setValue(cnpjFormatado, {
            emitEvent: false
          }); // Formata o valor enquanto o usuário digita
        }
      });
    }
  }

  formatarCNPJ(value: string): string {
    const cnpjNumeros = value.replace(/\D/g, ''); // Remove qualquer caractere que não seja número

    // Aplica a máscara conforme o número de dígitos
    return cnpjNumeros
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
  }

  aplicarMascaraCPF(socio: any) {
    if (socio.cpf) {
      socio.cpf = this.formatarCPF(socio.cpf);
    }
  }

  formatarCPF(value: string): string {
    const cpfNumeros = value.replace(/\D/g, ''); // Remove qualquer caractere que não seja número

    return cpfNumeros
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  }


  aplicarMascaraRG(socio: any) {
    if (socio.rg) {
      socio.rg = this.formatarRG(socio.rg);
    }
  }

  formatarRG(value: string): string {
    const rgNumeros = value.replace(/\D/g, ''); // Remove qualquer caractere que não seja número

    return rgNumeros
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1})$/, '$1-$2');
  }

  aplicarMascaraCEP() {
    const cepControl = this.form.get('cep');
    if (cepControl) {
      cepControl.valueChanges.subscribe(value => {
        if (value) {
          const cepFormatado = this.formatarCEP(value);
          cepControl.setValue(cepFormatado, {
            emitEvent: false
          });
        }
      });
    }
  }


  formatarCEP(value: string): string {
    const cepNumeros = value.replace(/\D/g, ''); // Remove qualquer caractere que não seja número

    if (cepNumeros.length > 5) {
      // Formata como XXXXX-XXX
      return cepNumeros.replace(/^(\d{5})(\d{1,3})$/, '$1-$2');
    } else {
      return cepNumeros; // Retorna o CEP enquanto ele é digitado, mesmo que incompleto
    }
  }

}
